import { t } from "i18next"

import type { LocalizedText } from "@/shared/i18n"

import type { FetchBaseQueryError } from "@reduxjs/toolkit/query"

const BUSINESS_SUBSCRIPTION_ERROR_MESSAGES: Record<number, LocalizedText> = {
  404: { key: "business-subscription-error-404", fallback: "Subscription not found" },
  409: { key: "business-subscription-error-409", fallback: "Conflict with current subscription state" },
  424: { key: "business-subscription-error-424", fallback: "Subscription cannot be processed right now" },
  504: { key: "business-subscription-error-504", fallback: "Payment gateway timeout. Please try again" }
}

export const mapBusinessSubscriptionError = (response: FetchBaseQueryError) => {
  const status = typeof response.status === "number" ? response.status : undefined

  if (status !== undefined && Object.hasOwn(BUSINESS_SUBSCRIPTION_ERROR_MESSAGES, status)) {
    const entry = BUSINESS_SUBSCRIPTION_ERROR_MESSAGES[status]
    return { status: "CUSTOM_ERROR" as const, error: t(entry.key, entry.fallback) }
  }

  if (status !== undefined && status >= 500) {
    return {
      status: "CUSTOM_ERROR" as const,
      error: t("business-subscription-error-500", "Server error. Please try again later")
    }
  }

  return response
}
